import React, { useEffect, useState } from 'react';

import DOMPurify from 'dompurify';

import Document from 'components/Document';
import Loader from 'components/Loader/index';
import { useAppDispatch } from 'hooks/useAppDispatch';
import useAppNavigate from 'hooks/useAppNavigate';
import { useAppSelector } from 'hooks/useAppSelector';
import { AppRoutes } from 'routes/routes.enums';
import * as notificationManager from 'notifications/index';
import { FailureNotificationType } from 'notifications/index';
import { documentsApi } from 'api/DocumentsApi';

import { TRANSCRIPT_AUTHORIZATION_DOCUMENT_TITLE } from './transcriptAuthorization.constants';

const TranscriptAuthorization = () => {
  const navigator = useAppNavigate();
  const dispatch = useAppDispatch();
  const { borrower, coBorrower } = useAppSelector((state) => state);
  const [transcriptionBorrowerAuthorizationDocument, setTranscriptionBorrowerAuthorizationDocument] = useState('');
  const [transcriptionCoborrowerAuthorizationDocument, setCoborrowerTranscriptionAuthorizationDocument] = useState('');
  const [loading, setLoading] = useState(true);
  const handleBack = () => {
    navigator(AppRoutes.Prequalification);
  };

  useEffect(() => {
    const getTranscriptionAuthorizationHtml = async () => {
      try {
        const transcriptionAuthorizationResponse = await documentsApi.downloadTranscriptAuthorization({
          firstName: borrower.firstName,
          lastName: borrower.lastName,
          ssn: borrower.personalIdNumber,
          state: borrower.state,
          city: borrower.city,
          streetName: borrower.streetName,
          streetNumber: borrower.streetNumber,
          zip: borrower.zip,
        });

        setTranscriptionBorrowerAuthorizationDocument(transcriptionAuthorizationResponse);

        //Temporary for now, for Andrew to decide whether to display the documents in a row, or in a separate tab
        if (coBorrower.firstName) {
          const transcriptionCobborowerAuthorizationResponse = await documentsApi.downloadTranscriptAuthorization({
            firstName: coBorrower.firstName,
            lastName: coBorrower.lastName,
            ssn: coBorrower.personalIdNumber,
            state: borrower.state,
            city: borrower.city,
            streetName: borrower.streetName,
            streetNumber: borrower.streetNumber,
            zip: borrower.zip,
          });

          setCoborrowerTranscriptionAuthorizationDocument(transcriptionCobborowerAuthorizationResponse);
        }
      } catch (error) {
        notificationManager.notifyFailure(FailureNotificationType.UnknownError);
      } finally {
        setLoading(false);
      }
    };

    getTranscriptionAuthorizationHtml();
  }, []);

  const borrowerFullName = `${borrower.firstName?.toUpperCase()} ${borrower.lastName?.toUpperCase()}`;
  const coborrowerFullName = `${coBorrower?.firstName?.toUpperCase()} ${coBorrower?.lastName?.toUpperCase()}`;

  const transcriptionAuthorization = (
    <>
      <Document
        title={TRANSCRIPT_AUTHORIZATION_DOCUMENT_TITLE}
        handleBack={handleBack}
        subtitle={borrowerFullName}
        showBackButton={!coBorrower.firstName}
      >
        <div
          className="content"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(transcriptionBorrowerAuthorizationDocument, { FORCE_BODY: true }),
          }}
        ></div>
      </Document>
      {coBorrower?.firstName && (
        <Document
          title={TRANSCRIPT_AUTHORIZATION_DOCUMENT_TITLE}
          handleBack={handleBack}
          subtitle={coborrowerFullName}
          showBackButton={true}
        >
          <div
            className="content"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(transcriptionCoborrowerAuthorizationDocument, { FORCE_BODY: true }),
            }}
          ></div>
        </Document>
      )}
    </>
  );

  return <>{loading ? <Loader /> : transcriptionAuthorization}</>;
};

export default TranscriptAuthorization;
